import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { configStore } from "../../../contexts/ConfigContext";
import Error from "../../Error/Error";
import { Button } from "@evidenceb/athena-common/design-system/Button";
import { defineMessages, useIntl } from "react-intl";
import errorImg from "./error.png";
import TabTitle from "../../../components/TabTitle/TabTitle";
import { pageTitles } from "../../../utils/messages";

import "./AuthenticationCustomErrors.scss";

const AuthenticationCustomErrors = () => {
    const { errorType } = useParams<{ errorType: string }>();
    const intl = useIntl();
    const {
        config: { auth },
    } = useContext(configStore);

    const error = auth.errors?.find((error) => error.urlPath === errorType);

    if (!error) return <Error />;

    return (
        <>
            <TabTitle title={pageTitles.authCustomError} />

            <div className="authentication-custom-error">
                <img src={errorImg} alt="" />
                <div className="authentication-custom-error__content">
                    <h1>{error.title}</h1>
                    <p>{error.description}</p>
                </div>
                <Button
                    label={intl.formatMessage(messages.closePage)}
                    onPress={() => {
                        close();
                    }}
                />
            </div>
        </>
    );
};
export default AuthenticationCustomErrors;

const messages = defineMessages({
    closePage: {
        id: "closePage",
        defaultMessage: "Close the page",
    },
});
